import { ChangeDetectionStrategy, Component } from '@angular/core';

@Component({
    selector: 'pp-side-panel-end-line-row',
    templateUrl: './side-panel-end-line-row.component.html',
    styleUrl: './side-panel-end-line-row.component.scss',
    standalone: false,
    changeDetection: ChangeDetectionStrategy.OnPush,
})
export class SidePanelEndLineRowComponent {

}
